<template>
  <div>
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>
    <template v-if="loadStatus">
      <div v-if="storeInventoryList.length">
        <vue-good-table
          :columns="columns"
          :rows="storeInventoryList"
          styleClass="vgt-table striped"
          style="width: 100%;"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm
          }"
          @on-page-change="onPageChange"
        >
          >
          <template slot="table-row" slot-scope="storeInventoryList">
            <div
              v-if="storeInventoryList.column.field === 'image'"
              class="image-holder"
            >
              <img :src="storeInventoryList.row.image" class="product-icon" />
            </div>
            <div v-else-if="storeInventoryList.column.field === 'cost'">
              <span>{{ formatCurrency(storeInventoryList.row.cost) }}</span>
            </div>
            <template
              v-else-if="storeInventoryList.column.field === 'adminOnly'"
            >
              <label class="toggle-button">
                <input
                  type="checkbox"
                  :checked="storeInventoryList.row.adminOnly"
                  @click.prevent="
                    toggleVisibility($event, storeInventoryList.row)
                  "
                />
                <span class="toggle-slider round"></span>
              </label>
            </template>
          </template>
        </vue-good-table>
      </div>
      <div v-else>
        <StoreInventoryZeroState />
      </div>
    </template>
    <Pagination
      :total-items="totalRecords"
      :page="serverParams.page"
      :items-per-page="serverParams.perPage"
      @page-change="pageChange"
      @perPageChange="handlePerPageChange"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { progressStatus, scrollPageToTop } from '../../helpers'
import { VueGoodTable } from 'vue-good-table'
import Util from '../../mixins/Util'

export default {
  name: 'StoreInventory',
  mixins: [Util],
  components: {
    VueGoodTable,
    StoreInventoryZeroState: () =>
      import('@/components/Inventory/StoreInventoryZeroState'),
    Skeleton: () => import('@/components/Universal/Skeleton'),
    Pagination: () => import('@/components/Universal/Pagination')
  },

  computed: {
    loadStatus() {
      return progressStatus(this.loadingStoreInventory)
    },
    ...mapState({
      loadingStoreInventory: state => state.inventory.loadingStoreInventory,
      storeInventoryList: state => state.inventory.storeInventoryList,
      searchTerm: state => state.globalTracking.searchTerm,
      totalRecords: state => state.inventory.storeTotalCount
    })
  },
  data() {
    return {
      onlyAdmin: true,
      columns: [
        {
          label: 'Product',
          field: 'image',
          width: '150px',
          sortable: false
        },
        {
          label: 'Product Name',
          field: 'title'
        },
        {
          label: 'Category',
          field: 'category',
          width: '150px'
        },
        {
          label: 'Item Cost',
          field: 'cost',
          width: '150px',
          hidden: !this.showPrices()
        },
        {
          label: 'Admin Only',
          field: 'adminOnly',
          width: '150px',
          sortable: false
        }
      ],
      serverParams: {
        page: 0,
        perPage: 50
      }
    }
  },
  created() {
    this.getStoreInventory({
      page: 1,
      perPage: this.serverParams.perPage
    })
  },
  methods: {
    ...mapActions('inventory', ['getStoreInventory']),
    toggleVisibility(event, row) {
      this.$store.dispatch('inventory/toggleAdminOnlyProduct', {
        id: parseInt(row.id),
        adminOnly: row.adminOnly,
        category: row.category === 'Gift' ? 'Product' : 'Bundle',
        originalIndex: row.originalIndex
      })
    },
    showPrices() {
      return this.$store.getters['team/showPrices']
    },
    onPageChange() {
      scrollPageToTop()
    },
    pageChange(page) {
      this.updateParams({ page: page })
      this.getNextChuckOfStoreInventory()
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChuckOfStoreInventory()
    },
    getNextChuckOfStoreInventory() {
      this.getStoreInventory({
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../global.scss';
/* https://github.com/euvl/vue-js-toggle-button */

h5 {
  margin: 3rem;
}
.image-holder {
  display: flex;
  width: 50%;
  justify-content: center;

  .product-icon {
    height: 45px;
    object-fit: contain;
    padding: 0px 15px;
  }
}
</style>
